import React from 'react';
import { Select, MenuItem, IconButton, Typography } from '@mui/material';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

/**
 * קומפוננטת פג'ינציה (Pagination) להצגת הניווט והמידע על כמות עמודים
 */
const GenericTablePagination = ({
  rows,
  rowsPerPage,
  currentPage,
  onRowsPerPageChange,
  onFirstPage,
  onLastPage,
  onNextPage,
  onPreviousPage
}) => {
  const totalPages = Math.ceil(rows.length / rowsPerPage) || 1;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {/* מידע: "עמוד X מתוך Y" */}
      <div
        style={{
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          padding: '10px 15px'
        }}
      >
        <Typography
          variant="caption"
          style={{ fontWeight: 'bold', textAlign: 'center' }}
        >
          {`עמוד ${currentPage} מתוך ${totalPages}`}
        </Typography>
      </div>

      {/* בחירת מספר שורות בעמוד */}
      <div>
        <Select
          value={rowsPerPage}
          onChange={onRowsPerPageChange}
          size="small"
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={100}>100</MenuItem>
          <MenuItem value={rows.length}>הכל</MenuItem>
        </Select>
      </div>

      {/* כפתורי ניווט */}
      <div>
        <IconButton onClick={onFirstPage} disabled={currentPage === 1}>
          <LastPageIcon />
        </IconButton>
        <IconButton onClick={onPreviousPage} disabled={currentPage === 1}>
          <NavigateNextIcon />
        </IconButton>
        <IconButton
          onClick={onNextPage}
          disabled={currentPage === totalPages}
        >
          <NavigateBeforeIcon />
        </IconButton>
        <IconButton
          onClick={onLastPage}
          disabled={currentPage === totalPages}
        >
          <FirstPageIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default GenericTablePagination;
